export default "__VITE_ASSET__18897ff5__"